import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/accordions/FaqFullPage.jsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/ParallaxContainer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/book-demo-all-in-one/Hero1.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/homes/home2/Testimonials.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/others/ClientSlider.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
